import { init } from 'services/api';
import { fetchConfig } from 'services/config';
import { Config } from 'store/config';
import { initializeDatadog } from 'utils/datadog';
import { getErrorFallbackHTML } from 'utils/errorFallback';
import { getConfigEnvStorage } from 'utils/storage';

async function bootstrap(): Promise<void> {
  const env = getConfigEnvStorage();
  let config: Config;

  try {
    config = await fetchConfig(env);
  } catch (e) {
    console.warn('Failed to fetch config, using fallback', e);
    config = (await import('store/config/fallback.json')).default;
  }

  init(config, true);

  try {
    await initializeDatadog(config.datadog, config.conviva, config.modelTiers, config.modelYears);
  } catch (e) {
    console.warn('Datadog initialization failed', e);
  }

  globalThis.appConfig = config;

  try {
    await import('./CoreApp');
  } catch (e) {
    console.warn('CoreApp failed to load', e);
    renderBootstrapError();
  }
}

function renderBootstrapError(): void {
  const root = document.getElementById('root');
  if (!root) return;

  root.innerHTML = `
    <div style="align-items:center;background:#111;color:white;display:flex;flex-direction:column;height:100vh;justify-content:center;text-align:center;width:100vw;position:fixed;top:0;left:0">
      ${getErrorFallbackHTML()}
    </div>
  `;
}

bootstrap();
